import { render, staticRenderFns } from "./DropdownLinks.vue?vue&type=template&id=5cd580db&"
import script from "./DropdownLinks.js?vue&type=script&lang=js&"
export * from "./DropdownLinks.js?vue&type=script&lang=js&"
import style0 from "./DropdownLinks.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports